import { Pipe, PipeTransform, inject } from '@angular/core';
import { Activity } from '@wilson/interfaces';
import { TimelineOverlapService } from '@wilson/shift-timeline/services';

@Pipe({
  name: 'timelineActivitiesOverlapLevels',
  standalone: true,
})
export class TimelineActivitiesOverlapLevelsPipe implements PipeTransform {
  private timelineOverlapService = inject(TimelineOverlapService);

  transform(shiftActivities: Activity[] | null) {
    if (shiftActivities) {
      const items = shiftActivities as (Activity & { id: string })[];
      const activitiesWithOverlapLevels =
        this.timelineOverlapService.determineOverlaps(items);

      const activitiesInOverlapLevels =
        this.timelineOverlapService.getActivitiesInRow(
          activitiesWithOverlapLevels,
        );

      return activitiesInOverlapLevels;
    } else {
      return [];
    }
  }
}
